import React from "react";
import IntlMessages from "@util/IntlMessages";
import "./mapComponent.less";
import "../list.less";
import { Button } from "../../../BP2Components";

const ListSearchButtons = ({
   selectedKeys,
   confirm,
   dataIndex,
   columnTechname,
   handleSearch,
   handleReset,
   clearFilters
}) => {
   return (
      <>
         <Button
            buttonType="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex, columnTechname)}
            size="small"
            style={{ width: 90, marginRight: 8 }}
         >
            <IntlMessages id="filter.search" />
         </Button>
         <Button
            onClick={() => handleReset(clearFilters, columnTechname)}
            size="small"
            style={{ width: 90 }}
         >
            <IntlMessages id="filter.reset" />
         </Button>
      </>
   );
};

export default ListSearchButtons;
